// Entry point. Side-effect style imports first (tokens → base →
// liquid-glass layer order matters for cascade), then bootstrap.

import './styles/tokens.scss';
import './styles/base.scss';
import './styles/liquid-glass.scss';
import './styles/avatar.scss';
import './styles/chat-list.scss';
import './styles/chat-row.scss';
import './styles/drawer.scss';
import './styles/right-panel.scss';
import './styles/settings.scss';
import './styles/qr-scan.scss';
import './styles/wizard.scss';
import './styles/cmdp.scss';
import './styles/chat-view.scss';
import './styles/polish.scss';
import './styles/pair-wall.scss';
import './styles/app.scss';

import { initTMA } from './tma';
import { App } from './App';
import { atmosWS } from './lib/atmosWS';

// Restore saved theme BEFORE TMA init so the user never sees a flash
// of the wrong scheme on cold start.
function restoreTheme(): void {
  const saved = localStorage.getItem("atmos.theme");
  if (saved === "dark") {
    document.body.classList.add("theme-dark");
  } else if (saved === "system") {
    const dark = window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
    document.body.classList.toggle("theme-dark", dark);
  } else if (saved === "light") {
    document.body.classList.remove("theme-dark");
  }
}

async function bootstrap(): Promise<void> {
  restoreTheme();
  const tma = await initTMA();

  // Hand TG initData to the WS layer so the first frame is signed
  // when we're inside Telegram. Outside TG this is empty + ignored.
  atmosWS.setInitData(tma.initData);

  // Auto-connect if we have a saved pair config from a prior session.
  // Inside TG the pair code can be empty — the initData is enough for
  // the Mac to verify. In a browser we still need both URL + code.
  const savedUrl = localStorage.getItem("atmos.ws_url") ?? "";
  const savedCode = localStorage.getItem("atmos.pair_code") ?? "";
  if (savedUrl && (savedCode || tma.insideTelegram)) {
    atmosWS.connect(savedUrl, savedCode);
  }

  const mount: HTMLElement | null = document.getElementById('app');
  if (!mount) {
    // index.html should always provide #app; bail loudly in dev.
    throw new Error('[atmos-miniapp] missing #app mount node');
  }
  mount.replaceChildren(
    App({ insideTelegram: tma.insideTelegram, userFirstName: tma.user?.firstName }),
  );

  const who: string = tma.user?.firstName ? ` user=${tma.user.firstName}` : '';
  // eslint-disable-next-line no-console
  console.log(`[atmos-miniapp] booted scheme=${tma.colorScheme}${who} tg=${tma.insideTelegram}`);
}

bootstrap();
